// @flow
/* eslint-disable ta-code-conventions/has-matching-test, ta-code-conventions/has-matching-storydoc */

/** Function to build the path to Saves page */
export const build = (servlet: string, { tripId }: { tripId: number }) => {
  let path = servlet;
  if (tripId) {
    path += `/${tripId}`;
  }
  return { path };
};

/** Function to parse tripId */
export const parse = (tripId: number) => ({ tripId });
